import { useState } from 'react';
import {
    TextField,
    InputAdornment,
    IconButton,
} from '@mui/material';
import { Search, Close } from '@mui/icons-material';


const SearchBar = ({ onSearch, disabled, width }) => {
    const [searchInput, setSearchInput] = useState('');

    const handleSearch = () => {
        // Trim to remove whitespace
        const query = searchInput.trim();
        if (query) {
            onSearch(query);
        }
    };

    const handleClear = () => {
        setSearchInput('');
        onSearch('');
    };

    return (
        <TextField
            fullWidth
            placeholder={disabled ? "Finish editing to search..." : "Search quizzes..."}
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            disabled={disabled}
            onKeyDown={(e) => {
                if (e.key === 'Enter' && !disabled && searchInput.trim()) {
                    handleSearch();
                }
            }}
            size="small"
            sx={{ width: `${width || '50vw'}` }}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <IconButton
                            size="small"
                            onClick={handleSearch}
                            disabled={disabled || !searchInput.trim()}
                        >
                            <Search />
                        </IconButton>
                    </InputAdornment>
                ),
                endAdornment: searchInput && (
                    <InputAdornment position="end">
                        <IconButton
                            size="small"
                            onClick={handleClear}
                            disabled={disabled}
                        >
                            <Close />
                        </IconButton>
                    </InputAdornment>
                )
            }}
        />
    );
};

export default SearchBar;